







































































































import { Component, Prop, Mixins } from "vue-property-decorator";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faChartLine, faLock } from "@fortawesome/free-solid-svg-icons";

library.add(faChartLine, faLock);

import StakeStatsVariation from "@/components/stake/StakeStatsVariation.vue";
import CurrencyMixin from "@/mixins/currency";

@Component({
  components: {
    FontAwesomeIcon,
    StakeStatsVariation,
  },
})
export default class StakeStats extends Mixins(CurrencyMixin) {
  @Prop(Number) private tokenPrice!: number;
  @Prop(Number) private tokenPriceVariation!: number;
  @Prop(Number) private totalStaked!: number;
  @Prop(Number) private dailyRewards!: number;
  @Prop(Number) private circulatingSupply!: number;

  get calcEstimatedAPR() {
    return (this.dailyRewards * 365) / this.totalStaked;
  }
}
